<template>

    <div class="component_3 myapplication__table__wrapper">
      <v-data-table
        :headers="$getHeaderType1(headerTxt, headers)"
        :items="inventors"
        hide-default-footer
        disable-pagination
        class="new__type__table__view"
        :mobile-breakpoint="MobileBreakPoint"
      >
        <template v-slot:item="{ item, index }">
          <tr>
            <td>
              {{ index + 1 }}
            </td>
            <td>
              <p>{{ item.name_ar }}</p>
              <p>{{ item.name_en }}</p>
            </td>

            <td :class="$vuetify.rtl ? 'text-right' : 'text-left' ">
              <p>{{ item.address_ar }}</p>
              <p>{{ item.address_en }}</p>
            </td>

            <td>
              {{ item.residence_country_code }}
            </td>
            <td>
              <div class="d-flex">
                <v-btn icon @click="fnGetInventorsDetail(item.seq)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  icon
                  v-show="!remove_restriction"
                  @click="fnDeleteInventorConfirm(item.seq)"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>

      <v-row class="ma-0 mt-15">
        <v-col class="pa-0 d-flex" cols="12">

          <v-spacer class="d-inline-flex"></v-spacer>
          <v-btn
            dense
            outlined
            dark
            color="#a01c2a"
            width="110px"
            height="40px"
            @click="fnNewInventor()"
          >
            {{ $t('common.button.add') }}
          </v-btn>
        </v-col>
      </v-row>

      <InventorMod
        :seq.sync="inventor_seq"
        :receipt_no.sync="receipt_no"
        v-if="mod_dialog"
        :remove_restriction.sync="remove_restriction"
        @success="fnSuccess()"
      />

      <InventorAdd
        :receipt_no.sync="receipt_no"
        v-if="add_dialog"
        @success="fnSuccess()"
      />

      <v-dialog v-model="confirm_dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">{{ $t('common.message.delete.confirm.title') }}</v-card-title>
          <v-card-text>{{ $t('common.message.delete.confirm.text') }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="sb_btn btn-actv" @click="fnDeleteInventor()">{{ $t('common.button.yes') }}</v-btn>
            <v-btn class="sb_btn btn-dactv" @click="confirm_dialog = false">{{ $t('common.button.no') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>

</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import InventorMod from './InventorMod'
import InventorAdd from './InventorAdd'
export default {
  props : {
    receipt_no: String,
    userInfo: Object,
    company: Object,
    remove_restriction: Boolean
  },
  components : {
    InventorMod,
    InventorAdd
  },
  data(){
    return {
      MobileBreakPoint : 0,
      mod_dialog: false,
      add_dialog: false,
      confirm_dialog : false,
      inventor_seq: 0,

      headerTxt : {
        prefix : 'component.inventor.',
        txt : [ '#', 'name','address','residence','' ]
      },

      headers: [
        { text: '#', align: 'center', width: 50, sortable: false},
        { text: 'Name', align: 'center', width: 200, sortable: false,},
        { text: 'Address', align: 'center', sortable: false, },
        { text: 'Residence',  align: 'center', width: 100, sortable: false, },
        { text: '',  align: 'center', width: 100, sortable: false, },
      ],
      inventors: [],
      auto_exist_yn : false
    }
  },
  mounted(){
    this.fnGetInventors()
  },
  methods: {
    fnGetInventors(){
      if(this.receipt_no != ''){
        requestApi({
          url: '/receivings/'+this.receipt_no+'/inventors',
          method: 'GET',
          callback: (res) => {
            if (res.res_code === '200') {
              this.inventors = res.data.list

              this.mod_dialog = false
              this.add_dialog = false

              for (let i = 0; i < this.inventors.length; i++) {
                if(this.inventors[i].name_ar === '' ||
                  this.inventors[i].address_ar === '' ||
                  (this.inventors[i].nationality_code === 'EG' && this.inventors[i].id_card_file_key === '')) {
                  this.auto_exist_yn = true
                  break
                } else {
                  this.auto_exist_yn = false
                }
              }
            } else {
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnGetInventors()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              }
            }
          }
        })
      }
    },

    fnSuccess(){
      requestApi({
        url: '/receivings/'+this.receipt_no+'/inventors',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.inventors = res.data.list

            this.mod_dialog = false
            this.add_dialog = false

            this.$emit('success', res.data.list.length)

          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnSuccess()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    //Inventor 상세보기 팝업
    fnGetInventorsDetail(inventor_seq){
      this.inventor_seq = inventor_seq
      this.mod_dialog = true
    },

    fnDeleteInventorConfirm(inventor_seq){
      if(!this.remove_restriction){
        this.inventor_seq = inventor_seq
        this.confirm_dialog = true
      }
    },

    //Inventor 삭제
    fnDeleteInventor(){
      if(!this.remove_restriction){
        requestApi({
          url: '/receivings/'+this.receipt_no+'/inventors/'+this.inventor_seq,
          method: 'DELETE',
          callback: (res) => {
            if (res.res_code === '200') {
              let option = {
                text : this.$t('common.message.delete.success'),
              }
              eventBus.$emit('SHOW_SNACKBAR', option)
              this.fnSuccess()

              this.confirm_dialog = false

            } else {
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnDeleteInventor()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              }
            }
          }
        })
      }
    },

    //Inventor 신규팝업
    fnNewInventor(){
      this.add_dialog = true
    }
  },
}

</script>